export default (date, cacheTime) => {
  const now = new Date().getTime();

  return (now - cacheTime) > date;
};
